import { MRT_ColumnDef, MRT_Row } from "material-react-table"
import { UserDto } from "@custom-types/user"
import { Icon } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"

export const getMaterialTableColumns: () => MRT_ColumnDef<UserDto>[] = () => [
  {
    accessorKey: "first_name",
    header: "Name",
    size: 300,
  },
  {
    accessorKey: "last_name",
    header: "Surname",
    size: 300,
  },
  {
    accessorKey: "key",
    header: "Email",
    size: 300,
  },
  {
    accessorKey: "organisation_key",
    header: "Org. Mnemonic",
    size: 200,
  },
  {
    accessorKey: "active",
    header: "Active",
    Cell: ({ row }: { row: MRT_Row<UserDto> }) => (
      <Icon fontSize="small">{row.original.active ? <CheckIcon /> : <CloseIcon />}</Icon>
    ),
    size: 50,
    muiTableBodyCellProps: {
      align: "center",
    },
  },
]
